import './styles/main.css'
import 'cm-chessboard/assets/chessboard.css'
import 'cm-chessboard/assets/extensions/markers/markers.css'

import { h } from './ui/dom.js'
import { on } from './lib/bus.js'
import { toast } from './ui/toast.js'
import { state, setPersistence, restoreProject } from './lib/state.js'
import { buildSnapshot, saveProject, loadProject, clearProject } from './lib/storage.js'
import { confirmDialog } from './ui/dialog.js'
import { mountToasts } from './ui/toast.js'
import { mountPgnPanel } from './ui/pgnPanel.js'
import { mountMoveList } from './ui/moveList.js'
import { mountPlayer } from './ui/player.js'
import { mountOverlay } from './ui/overlay.js'
import { mountSettingsPanel } from './ui/settingsPanel.js'
import { mountExportPanel } from './ui/exportPanel.js'

const app = document.querySelector('#app')

// --- Topbar ---------------------------------------------------------------
const saveState = h('div.save-state', {}, h('span.dot'), h('span.save-label', {}, 'Local project'))
const resetBtn = h(
  'button.btn.ghost',
  {
    type: 'button',
    onClick: async () => {
      const ok = await confirmDialog({
        title: 'Reset project?',
        message:
          'This clears the loaded game, every timestamp and the saved local project. Export the project JSON first if you want a backup.',
        confirmLabel: 'Reset everything',
        danger: true,
      })
      if (!ok) return
      clearProject()
      location.reload()
    },
  },
  'Reset',
)
const topbar = h(
  'header.topbar',
  {},
  h(
    'div.brand',
    {},
    h('span.brand-mark', { 'aria-hidden': 'true' }, '♞'),
    h('span.brand-name', {}, 'PGN Sync'),
    h('span.brand-sub', {}, 'board overlay for OTB footage'),
  ),
  h('div.topbar-status', {}, saveState, resetBtn),
)

// --- Workspace ------------------------------------------------------------
const workspace = h('main.workspace')
const stageCol = h('section.stage-col')
const inspector = h('aside.inspector')

// --- Footer hints ---------------------------------------------------------
const hint = (keys, label) =>
  h('span.hint-item', {}, ...keys.map((k) => h('kbd', {}, k)), ` ${label}`)
const hintbar = h(
  'footer.hintbar',
  {},
  hint(['Space'], 'play'),
  hint([',', '.'], 'frame'),
  hint(['←', '→'], 'seek'),
  hint(['↑', '↓'], 'move'),
  hint(['Enter'], 'tag move'),
  hint(['⌫'], 'untag'),
  hint(['[', ']'], 'speed'),
  hint(['J'], 'jump to tag'),
)

app.append(topbar, workspace, hintbar)
mountMoveList(workspace)
workspace.append(stageCol, inspector)
mountPlayer(stageCol)
mountOverlay()
mountPgnPanel(inspector)
mountSettingsPanel(inspector)
mountExportPanel(inspector)
mountToasts(document.body)

on('autofill', () =>
  toast('Timestamps pre-filled as a scaffold — refine each move as you watch (Video panel to adjust)'),
)

// --- Restore + autosave ----------------------------------------------------
const saved = loadProject()
if (saved) restoreProject(saved)

const saveLabel = saveState.querySelector('.save-label')
let saveTimer = null
const saveNow = () => {
  saveTimer = null
  const ok = saveProject(buildSnapshot(state))
  saveState.classList.toggle('saved', ok)
  saveLabel.textContent = ok ? 'Saved in this browser' : 'Save failed — storage full?'
}
setPersistence(() => {
  clearTimeout(saveTimer)
  saveTimer = setTimeout(saveNow, 350)
})
// Don't lose the last action to the debounce when the tab closes.
window.addEventListener('beforeunload', () => {
  if (saveTimer != null) {
    clearTimeout(saveTimer)
    saveNow()
  }
})

export { stageCol, inspector }
